module.exports = __webpack_public_path__ + "ca38b1a039c9bc784bcf94a2a52a8c76.png";